import axiosInstance from "../utils/axios"

export const iscoService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/isco',{ params })
    return response.data
  },
  fetchAllWithoutPagination: async () => {
    const response = await axiosInstance.get('/isco/all')
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/isco/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/isco', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/isco/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/isco/${id}`)
    return response.data
  },
}
